export default "/images/13 Step2Plan-Consultant-To view goals and action plans-01.png?b2695e9080ea767cbed7287762114c88";